import { Component, OnInit } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { HttpService } from '../../shared/http.service';
import { AlertService } from '../../shared/alert.service';
import { ActivatedRoute, Params } from '@angular/router';
import { BannerResponse, BannerRequest } from '@builtbybros/al-model';
import { QueryParam } from '../../shared/query-param';


@Component({
  selector: 'app-banner-categories',
  templateUrl: './banner-categories.component.html',
  styleUrls: ['./banner-categories.component.scss']
})
export class BannerCategoriesComponent implements OnInit {
  banners = [];
  btnMsg = 'Confirmar';
  h1 = 'Banner';
  bannersReady = false;
  bannerUrl = '/banner/';
  role = 2;
  title = 'Banner';

  msg = {
    'bannerSuccess': 'Banner actualizado correctamente',
    'bannerError': 'Ocurrió un error al actualizar los banners'
  };


  constructor(private dragulaService: DragulaService,
              private httpService: HttpService,
              private route: ActivatedRoute,
              private alertService: AlertService) {
    dragulaService.drag.subscribe((value) => {
      this.onDrag(value.slice(1));
    });
    dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1));
    });
    dragulaService.over.subscribe((value) => {
      this.onOver(value.slice(1));
    });
    dragulaService.out.subscribe((value) => {
      this.onOut(value.slice(1));
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['bannerCategory']) {
        this.role = +params['bannerCategory'];
        const p = new Array<QueryParam>();
        p[0] = new QueryParam('role', this.role.toString());
        this.httpService.getWithParams('/Banner/Ranking', p, BannerResponse.All)
          .subscribe(
            response => {
              this.banners = response.objects;
              this.bannersReady = true;
            }
          );
      }
    });
  }

  private onDrag(args) {
    let [e, el] = args;
    // do something
  }

  private onDrop(args) {
    let [e, el] = args;
    // do something
  }

  private onOver(args) {
    let [e, el, container] = args;
    // do something
  }

  private onOut(args) {
    let [e, el, container] = args;
    // do something
  }


  submitForm() {
    let body = {};
    body['ranking'] = [];
    for (let item of this.banners) {
      body['ranking'].push(item.id);
    }
    this.httpService.updateRaw('/BannerRanking/Update', body)
      .subscribe(
        response => {
          this.alertService.success(this.msg['bannerSuccess']);
        },
        error => {
          this.alertService.error(this.msg['bannerError']);
        }
      );

  }

  addItem(value: number) {
    const responseExpected = new BannerResponse.Banner();
    this.httpService.get(this.bannerUrl, value, responseExpected)
      .subscribe(
        createResponse => {
          if (createResponse) {
            this.banners.push(createResponse);
          }
        }
      );
  }

  delete(id) {
    if (confirm('eliminar?')) {
      this.banners.splice(this.banners.findIndex((item) => {
        return item.id === id;
      }), 1);
      this.httpService.delete('/Banner/', id)
        .subscribe(
          response => {
            this.alertService.success('Banner borrado correctamente');
          },
          error => {
            this.alertService.error('Ocurrió un error al borrar el banner');
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/banner-categories/banner-categories.component.ts